/**
 * Absolute-cap merge for ComposerCollectIntake file staging.
 *
 * totalAssets = files.length + captureCount must stay ≤ maxAssets across
 * successive attaches. The previous room math (`slice(0, prev.length + room)`)
 * ignored already-staged files and let N attaches stage up to N×room files.
 *
 * one-shot, not cached — pure merge helper with no LLM / prompt scope.
 */

interface AcceptStagedFilesArgs {
  prevFiles: Array<File>;
  incoming: Array<File>;
  /** URL captures already counting against the shared asset cap. */
  captureCount: number;
  maxAssets: number;
}

/**
 * Append `incoming` to `prevFiles`, then slice to the absolute file slots left
 * after URL captures: `max(0, maxAssets - captureCount)`.
 */
export function acceptStagedFiles(args: AcceptStagedFilesArgs): Array<File> {
  const { prevFiles, incoming, captureCount, maxAssets } = args;
  const fileCap = Math.max(0, maxAssets - captureCount);
  return [...prevFiles, ...incoming].slice(0, fileCap);
}
